// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Common = require("../utils/Common.res.js");
var Js_exn = require("rescript/lib/js/js_exn.js");
var Core__JSON = require("@rescript/core/src/Core__JSON.res.js");
var MM_context = require("../mm-utils/MM_context.res.js");
var MM_provers = require("../mm-utils/MM_provers.res.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Belt_Result = require("rescript/lib/js/belt_Result.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Array = require("@rescript/core/src/Core__Array.res.js");
var MM_wrk_editor = require("../worker/MM_wrk_editor.res.js");
var MM_substitution = require("../mm-utils/MM_substitution.res.js");
var MM_wrk_ctx_data = require("../worker/MM_wrk_ctx_data.res.js");
var Belt_HashMapString = require("rescript/lib/js/belt_HashMapString.js");
var Belt_HashSetString = require("rescript/lib/js/belt_HashSetString.js");
var Caml_js_exceptions = require("rescript/lib/js/caml_js_exceptions.js");
var Expln_utils_promise = require("../../rescript-utils/main/Expln_utils_promise.res.js");
var Expln_utils_jsonParse = require("../../rescript-utils/main/Expln_utils_jsonParse.res.js");
var MM_wrk_editor_substitution = require("../worker/MM_wrk_editor_substitution.res.js");

function okResp(res) {
  return {
          isOk: true,
          res: res,
          err: undefined
        };
}

function errResp(msg) {
  return {
          isOk: false,
          res: undefined,
          err: msg
        };
}

function syntaxTreeNodeToJson(node, ctxConstIntToSymExn) {
  return Object.fromEntries([
              [
                "id",
                node.id
              ],
              [
                "nodeType",
                "expr"
              ],
              [
                "exprType",
                ctxConstIntToSymExn(node.typ)
              ],
              [
                "label",
                node.label
              ],
              [
                "children",
                node.children.map(function (__x) {
                      if (__x.TAG === "Subtree") {
                        return syntaxTreeNodeToJson(__x._0, ctxConstIntToSymExn);
                      } else {
                        return Object.fromEntries([
                                    [
                                      "id",
                                      __x.id
                                    ],
                                    [
                                      "nodeType",
                                      "sym"
                                    ],
                                    [
                                      "sym",
                                      __x.sym
                                    ],
                                    [
                                      "isVar",
                                      __x.isVar
                                    ]
                                  ]);
                      }
                    })
              ]
            ]);
}

function syntaxTreeToJson(stmt, ctxConstIntToSymExn) {
  var match = stmt.cont;
  if (match.TAG === "Text") {
    return null;
  }
  var match$1 = match._0;
  return Object.fromEntries([
              [
                "exprType",
                match$1.exprTyp
              ],
              [
                "root",
                syntaxTreeNodeToJson(match$1.root, ctxConstIntToSymExn)
              ]
            ]);
}

function getSelectedFragmentId(stmt) {
  var stmtContTreeData = stmt.cont;
  if (stmtContTreeData.TAG === "Text") {
    return null;
  }
  var node = MM_wrk_editor.getSelectedSubtree(stmtContTreeData._0);
  if (node !== undefined) {
    if (node.TAG === "Subtree") {
      return node._0.id;
    } else {
      return node.id;
    }
  } else {
    return null;
  }
}

function stmtToJson(stmt, ctxConstIntToSymExn) {
  var proofStatus = stmt.proofStatus;
  var tmp;
  if (proofStatus !== undefined) {
    switch (proofStatus) {
      case "Ready" :
          tmp = "v";
          break;
      case "Waiting" :
          tmp = "~";
          break;
      case "NoJstf" :
          tmp = "?";
          break;
      case "JstfIsIncorrect" :
          tmp = "x";
          break;
      
    }
  } else {
    tmp = null;
  }
  var match = stmt.stmtErr;
  return Object.fromEntries([
              [
                "id",
                stmt.id
              ],
              [
                "status",
                tmp
              ],
              [
                "label",
                stmt.label
              ],
              [
                "isHyp",
                stmt.typ === "E"
              ],
              [
                "isGoal",
                stmt.isGoal
              ],
              [
                "isBkm",
                stmt.isBkm
              ],
              [
                "jstfText",
                stmt.jstfText
              ],
              [
                "jstf",
                Belt_Result.mapWithDefault(MM_wrk_editor.parseJstf(stmt.jstfText), null, (function (jstf) {
                        if (jstf !== undefined) {
                          return Object.fromEntries([
                                      [
                                        "args",
                                        jstf.args.map(function (__x) {
                                              return __x;
                                            })
                                      ],
                                      [
                                        "asrt",
                                        jstf.label
                                      ]
                                    ]);
                        } else {
                          return null;
                        }
                      }))
              ],
              [
                "stmt",
                MM_wrk_editor.contToStr(stmt.cont)
              ],
              [
                "tree",
                ctxConstIntToSymExn !== undefined ? syntaxTreeToJson(stmt, ctxConstIntToSymExn) : null
              ],
              [
                "fragId",
                getSelectedFragmentId(stmt)
              ],
              [
                "stmtErr",
                match !== undefined ? Object.fromEntries([
                        [
                          "code",
                          match.code
                        ],
                        [
                          "msg",
                          match.msg
                        ]
                      ]) : null
              ],
              [
                "unifErr",
                Belt_Option.getWithDefault(Belt_Option.map(stmt.unifErr, (function (prim) {
                            return prim;
                          })), null)
              ],
              [
                "syntaxErr",
                Belt_Option.getWithDefault(Belt_Option.map(stmt.syntaxErr, (function (prim) {
                            return prim;
                          })), null)
              ]
            ]);
}

function getAllSteps(state) {
  var ctxConstIntToSymExn = Belt_Option.map(state.wrkCtx, (function (wrkCtx) {
          return function (__x) {
            return MM_context.ctxIntToSymExn(wrkCtx, __x);
          };
        }));
  return state.stmts.map(function (__x) {
              return stmtToJson(__x, ctxConstIntToSymExn);
            });
}

var stateCached = {
  contents: undefined
};

var stateJsonCached = {
  contents: undefined
};

function labelsToExprs(st, labels) {
  return Core__Array.reduce(labels, {
              TAG: "Ok",
              _0: []
            }, (function (res, label) {
                if (res.TAG !== "Ok") {
                  return res;
                }
                var stmt = MM_wrk_editor.editorGetStmtByLabel(st, label);
                if (stmt === undefined) {
                  return {
                          TAG: "Error",
                          _0: "Cannot find a step by label '" + label + "'"
                        };
                }
                var expr = stmt.expr;
                if (expr !== undefined) {
                  res._0.push(expr);
                  return res;
                } else {
                  return {
                          TAG: "Error",
                          _0: "Internal error: the step with label '" + label + "' doesn't have expr."
                        };
                }
              }));
}

function apiMatcherToMatcher(ctx, matcher) {
  if (Belt_Option.isNone(matcher.res) && matcher.hyps.length === 0) {
    return {
            TAG: "Error",
            _0: "'res' and 'hyps' must not be empty at the same time."
          };
  }
  var hypMatchers = Core__Array.reduce(matcher.hyps, {
        TAG: "Ok",
        _0: []
      }, (function (res, hypMatcher) {
          if (res.TAG !== "Ok") {
            return res;
          }
          var hypMatchers = res._0;
          var label = hypMatcher.label;
          if (label !== undefined) {
            var match = hypMatcher.idx;
            if (match !== undefined) {
              return {
                      TAG: "Error",
                      _0: "Only one of 'label' or 'idx' must be specified for each hypothesis matcher"
                    };
            } else {
              hypMatchers.push({
                    TAG: "Label",
                    _0: label
                  });
              return res;
            }
          }
          var idx = hypMatcher.idx;
          if (idx !== undefined) {
            hypMatchers.push({
                  TAG: "Idx",
                  _0: idx
                });
            return res;
          } else {
            return {
                    TAG: "Error",
                    _0: "Either 'label' or 'idx' must be specified for each hypothesis matcher"
                  };
          }
        }));
  if (hypMatchers.TAG !== "Ok") {
    return {
            TAG: "Error",
            _0: hypMatchers._0
          };
  }
  try {
    var overrideHyps = matcher.hyps.map(function (hypMatcher) {
          return MM_context.ctxStrToIntsExn(ctx, hypMatcher.pat);
        });
    var res = matcher.res;
    var frame = MM_context.createFrame(ctx, 0, true, "###temp_asrt###", Common.getSpaceSeparatedValuesAsArray(res !== undefined ? res : matcher.hyps[0].pat), undefined, undefined, undefined, true, true, overrideHyps, undefined, undefined, undefined, undefined);
    return {
            TAG: "Ok",
            _0: {
              frm: MM_substitution.prepareFrmSubsDataForFrame(frame),
              matchAsrt: Belt_Option.isSome(matcher.res),
              hypMatchers: hypMatchers._0
            }
          };
  }
  catch (raw_exn){
    var exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
    if (exn.RE_EXN_ID === Common.MmException) {
      return {
              TAG: "Error",
              _0: exn._1.msg
            };
    }
    if (exn.RE_EXN_ID === Js_exn.$$Error) {
      return {
              TAG: "Error",
              _0: Belt_Option.getWithDefault(exn._1.message, "Unknown error.")
            };
    }
    throw exn;
  }
}

function optArrayToMatchers(state, matches) {
  if (matches === undefined) {
    return {
            TAG: "Ok",
            _0: undefined
          };
  }
  var wrkCtx = state.wrkCtx;
  if (wrkCtx === undefined) {
    return {
            TAG: "Error",
            _0: "Error: cannot parse patters to match"
          };
  }
  var wrkCtx$1 = Caml_option.valFromOption(wrkCtx);
  return Belt_Result.map(Core__Array.reduce(matches, {
                  TAG: "Ok",
                  _0: []
                }, (function (res, matcher) {
                    if (res.TAG !== "Ok") {
                      return res;
                    }
                    var res$1 = res._0;
                    var msg = apiMatcherToMatcher(wrkCtx$1, matcher);
                    if (msg.TAG !== "Ok") {
                      return {
                              TAG: "Error",
                              _0: msg._0
                            };
                    }
                    res$1.push(msg._0);
                    return {
                            TAG: "Ok",
                            _0: res$1
                          };
                  })), (function (arr) {
                return arr;
              }));
}

var lastPreCtxV = {
  contents: -100
};

var sortedFrames = {
  contents: Belt_HashMapString.make(0)
};

function validateStepType(typ) {
  if (typ !== undefined) {
    if (typ === "h" || typ === "p" || typ === "g") {
      return {
              TAG: "Ok",
              _0: typ
            };
    } else {
      return {
              TAG: "Error",
              _0: "Step type must be one of: h,p,g."
            };
    }
  } else {
    return {
            TAG: "Ok",
            _0: typ
          };
  }
}

function tokenTypeToStr(tokenType) {
  switch (tokenType) {
    case "C" :
        return "constant";
    case "V" :
        return "variable";
    case "F" :
        return "label of a floating";
    case "E" :
        return "label of an essential hypothesis";
    case "A" :
        return "label of an axiom";
    case "P" :
        return "label of a theorem";
    
  }
}

function validateVarNamesAreUnique(vars) {
  if (vars === undefined) {
    return {
            TAG: "Ok",
            _0: undefined
          };
  }
  var allVarNames = vars.filter(function ($$var) {
          return $$var.length > 1;
        }).map(function ($$var) {
        return $$var[1];
      });
  var uniqueVarNames = Belt_HashSetString.fromArray(allVarNames);
  if (allVarNames.length === Belt_HashSetString.size(uniqueVarNames)) {
    return {
            TAG: "Ok",
            _0: undefined
          };
  } else {
    return {
            TAG: "Error",
            _0: "Cannot create variables because two or more variables have same name."
          };
  }
}

function validateVarNamesNotPresentInCtx(st, vars) {
  if (vars === undefined) {
    return {
            TAG: "Ok",
            _0: undefined
          };
  }
  var wrkCtx = st.wrkCtx;
  if (wrkCtx === undefined) {
    return {
            TAG: "Error",
            _0: "Cannot add new variables because of errors in the editor."
          };
  }
  var wrkCtx$1 = Caml_option.valFromOption(wrkCtx);
  var definedVars = vars.filter(function ($$var) {
                return $$var.length > 1;
              }).map(function ($$var) {
              return $$var[1];
            }).map(function (varName) {
            return [
                    varName,
                    MM_context.getTokenType(wrkCtx$1, varName)
                  ];
          }).filter(function (param) {
          return Belt_Option.isSome(param[1]);
        }).map(function (param) {
        return [
                param[0],
                Belt_Option.getExn(param[1])
              ];
      });
  if (definedVars.length === 0) {
    return {
            TAG: "Ok",
            _0: undefined
          };
  }
  var varTypes = definedVars.map(function (param) {
          return param[0] + " is a " + tokenTypeToStr(param[1]);
        }).join("; ");
  return {
          TAG: "Error",
          _0: "Cannot create variables because names of some of them are already in use: " + varTypes + "."
        };
}

var logApiCallsToConsole = {
  contents: false
};

function setLogApiCallsToConsole(params) {
  var bool = Core__JSON.Decode.bool(params);
  if (bool !== undefined) {
    logApiCallsToConsole.contents = bool;
    return Expln_utils_promise.promiseResolved({
                TAG: "Ok",
                _0: null
              });
  } else {
    return Expln_utils_promise.promiseResolved({
                TAG: "Error",
                _0: "The parameter of setLogApiCallsToConsole() must be a boolean."
              });
  }
}

var setLogApiCallsToConsoleRef = {
  contents: undefined
};

var apiShowInfoMsgRef = {
  contents: undefined
};

var apiShowErrMsgRef = {
  contents: undefined
};

var getStateRef = {
  contents: undefined
};

var proveBottomUpRef = {
  contents: undefined
};

var unifyAllRef = {
  contents: undefined
};

var addStepsRef = {
  contents: undefined
};

var updateStepsRef = {
  contents: undefined
};

var deleteStepsRef = {
  contents: undefined
};

var getTokenTypeRef = {
  contents: undefined
};

var substituteRef = {
  contents: undefined
};

var mergeDuplicatedStepsRef = {
  contents: undefined
};

var editorSetContIsHiddenRef = {
  contents: undefined
};

var editorBuildSyntaxTreesRef = {
  contents: undefined
};

function makeApiFuncRef(ref) {
  return function (params) {
    var func = ref.contents;
    if (func !== undefined) {
      return func(params);
    } else {
      return Js_exn.raiseError("api function is not defined");
    }
  };
}

var api = {
  setLogApiCallsToConsole: makeApiFuncRef(setLogApiCallsToConsoleRef),
  showInfoMsg: makeApiFuncRef(apiShowInfoMsgRef),
  showErrMsg: makeApiFuncRef(apiShowErrMsgRef),
  editor: {
    getState: makeApiFuncRef(getStateRef),
    proveBottomUp: makeApiFuncRef(proveBottomUpRef),
    unifyAll: makeApiFuncRef(unifyAllRef),
    addSteps: makeApiFuncRef(addStepsRef),
    updateSteps: makeApiFuncRef(updateStepsRef),
    deleteSteps: makeApiFuncRef(deleteStepsRef),
    getTokenType: makeApiFuncRef(getTokenTypeRef),
    substitute: makeApiFuncRef(substituteRef),
    mergeDuplicatedSteps: makeApiFuncRef(mergeDuplicatedStepsRef),
    setContentIsHidden: makeApiFuncRef(editorSetContIsHiddenRef),
    buildSyntaxTrees: makeApiFuncRef(editorBuildSyntaxTreesRef)
  }
};

var apiCallCnt = {
  contents: 0
};

function makeApiFunc(name, func) {
  return function (params) {
    apiCallCnt.contents = apiCallCnt.contents + 1 | 0;
    var apiCallId = apiCallCnt.contents;
    if (logApiCallsToConsole.contents) {
      console.log("[" + String(apiCallId) + "] <<< " + name, params);
    }
    return Expln_utils_promise.promiseMap(func(params), (function (res) {
                  var resp;
                  resp = res.TAG === "Ok" ? okResp(res._0) : errResp(res._0);
                  if (logApiCallsToConsole.contents) {
                    console.log("[" + String(apiCallId) + "] >>> ", resp);
                  }
                  return resp;
                }));
  };
}

function updateEditorApi(state, showInfoMsg, showErrMsg, setState, setEditorContIsHidden, canStartProvingBottomUp, startProvingBottomUp, canStartUnifyAll, startUnifyAll, buildSyntaxTrees) {
  setLogApiCallsToConsoleRef.contents = makeApiFunc("setLogApiCallsToConsole", setLogApiCallsToConsole);
  apiShowInfoMsgRef.contents = makeApiFunc("showInfoMsg", (function (params) {
          var msg = Core__JSON.Decode.string(params);
          if (msg !== undefined) {
            showInfoMsg(msg);
            return Expln_utils_promise.promiseResolved({
                        TAG: "Ok",
                        _0: null
                      });
          } else {
            return Expln_utils_promise.promiseResolved({
                        TAG: "Error",
                        _0: "The parameter of showInfoMsg() must be a string."
                      });
          }
        }));
  apiShowErrMsgRef.contents = makeApiFunc("showErrMsg", (function (params) {
          var msg = Core__JSON.Decode.string(params);
          if (msg !== undefined) {
            showErrMsg(msg);
            return Expln_utils_promise.promiseResolved({
                        TAG: "Ok",
                        _0: null
                      });
          } else {
            return Expln_utils_promise.promiseResolved({
                        TAG: "Error",
                        _0: "The parameter of showErrMsg() must be a string."
                      });
          }
        }));
  getStateRef.contents = makeApiFunc("editor.getState", (function (param) {
          var stateCached$1 = stateCached.contents;
          var canUseCachedValue = stateCached$1 !== undefined ? stateCached$1 === state : false;
          if (canUseCachedValue) {
            return Expln_utils_promise.promiseResolved({
                        TAG: "Ok",
                        _0: Belt_Option.getExn(stateJsonCached.contents)
                      });
          }
          var stmtIdToLabel = Belt_HashMapString.fromArray(state.stmts.map(function (stmt) {
                    return [
                            stmt.id,
                            stmt.label
                          ];
                  }));
          var varDefs = MM_wrk_ctx_data.textToVarDefs(state.varsText);
          var tmp;
          tmp = varDefs.TAG === "Ok" ? varDefs._0.map(function (varDef) {
                  return varDef.map(function (__x) {
                              return __x;
                            });
                }) : null;
          var stateJson = Object.fromEntries([
                [
                  "descr",
                  state.descr
                ],
                [
                  "varsText",
                  state.varsText
                ],
                [
                  "varsErr",
                  Belt_Option.getWithDefault(Belt_Option.map(state.varsErr, (function (prim) {
                              return prim;
                            })), null)
                ],
                [
                  "vars",
                  tmp
                ],
                [
                  "disjText",
                  state.disjText
                ],
                [
                  "disjErr",
                  Belt_Option.getWithDefault(Belt_Option.map(state.disjErr, (function (prim) {
                              return prim;
                            })), null)
                ],
                [
                  "disj",
                  Common.multilineTextToNonEmptyLines(state.disjText).map(function (disjLine) {
                        return disjLine.split(" ").map(function (__x) {
                                        return __x.trim();
                                      }).filter(function (str) {
                                      return str !== "";
                                    }).map(function (__x) {
                                    return __x;
                                  });
                      })
                ],
                [
                  "steps",
                  getAllSteps(state)
                ],
                [
                  "selectedSteps",
                  state.checkedStmtIds.map(function (param) {
                            return Belt_HashMapString.get(stmtIdToLabel, param[0]);
                          }).filter(Belt_Option.isSome).map(Belt_Option.getExn)
                ]
              ]);
          stateCached.contents = state;
          stateJsonCached.contents = stateJson;
          return Expln_utils_promise.promiseResolved({
                      TAG: "Ok",
                      _0: stateJson
                    });
        }));
  proveBottomUpRef.contents = makeApiFunc("editor.proveBottomUp", (function (params) {
          if (!canStartProvingBottomUp) {
            return Expln_utils_promise.promiseResolved({
                        TAG: "Error",
                        _0: "Cannot start proving bottom-up because either there are syntax errors in the editor or edit is in progress."
                      });
          }
          var parseResult = Expln_utils_jsonParse.fromJson(params, (function (__x) {
                  return Expln_utils_jsonParse.asObj(__x, (function (d) {
                                return {
                                        delayBeforeStartMs: Expln_utils_jsonParse.intOpt(d, "delayBeforeStartMs", undefined, undefined),
                                        stepToProve: Expln_utils_jsonParse.str(d, "stepToProve", undefined, undefined),
                                        maxSearchDepth: Expln_utils_jsonParse.$$int(d, "maxSearchDepth", undefined, undefined),
                                        debugLevel: Expln_utils_jsonParse.intOpt(d, "debugLevel", undefined, undefined),
                                        selectFirstFoundProof: Expln_utils_jsonParse.boolOpt(d, "selectFirstFoundProof", undefined, undefined),
                                        frameParams: Expln_utils_jsonParse.arr(d, "frameParameters", (function (__x) {
                                                return Expln_utils_jsonParse.asObj(__x, (function (d) {
                                                              return {
                                                                      minDist: Expln_utils_jsonParse.intOpt(d, "minDist", undefined, undefined),
                                                                      maxDist: Expln_utils_jsonParse.intOpt(d, "maxDist", undefined, undefined),
                                                                      matches: Expln_utils_jsonParse.arrOpt(d, "matches", (function (__x) {
                                                                              return Expln_utils_jsonParse.asObj(__x, (function (d) {
                                                                                            return {
                                                                                                    res: Expln_utils_jsonParse.strOpt(d, "res", undefined, undefined),
                                                                                                    hyps: Expln_utils_jsonParse.arr(d, "hyps", (function (__x) {
                                                                                                            return Expln_utils_jsonParse.asObj(__x, (function (d) {
                                                                                                                          return {
                                                                                                                                  label: Expln_utils_jsonParse.strOpt(d, "label", undefined, undefined),
                                                                                                                                  idx: Expln_utils_jsonParse.intOpt(d, "idx", undefined, undefined),
                                                                                                                                  pat: Expln_utils_jsonParse.str(d, "pat", undefined, undefined)
                                                                                                                                };
                                                                                                                        }), undefined, undefined);
                                                                                                          }), undefined, (function () {
                                                                                                            return [];
                                                                                                          }))
                                                                                                  };
                                                                                          }), undefined, undefined);
                                                                            }), undefined, undefined),
                                                                      framesToUse: Expln_utils_jsonParse.arrOpt(d, "frames", (function (__x) {
                                                                              return Expln_utils_jsonParse.asStr(__x, undefined, undefined);
                                                                            }), undefined, undefined),
                                                                      stepsToUse: Expln_utils_jsonParse.arr(d, "stepsToDeriveFrom", (function (__x) {
                                                                              return Expln_utils_jsonParse.asStr(__x, undefined, undefined);
                                                                            }), undefined, undefined),
                                                                      allowNewDisjointsForExistingVariables: Expln_utils_jsonParse.bool(d, "allowNewDisjointsForExistingVariables", undefined, undefined),
                                                                      allowNewSteps: Expln_utils_jsonParse.bool(d, "allowNewSteps", undefined, undefined),
                                                                      allowNewVariables: Expln_utils_jsonParse.bool(d, "allowNewVariables", undefined, undefined),
                                                                      statementLengthRestriction: Expln_utils_jsonParse.str(d, "statementLengthRestriction", (function (str) {
                                                                              var match = MM_provers.lengthRestrictFromStr(str);
                                                                              if (match !== undefined) {
                                                                                return {
                                                                                        TAG: "Ok",
                                                                                        _0: str
                                                                                      };
                                                                              } else {
                                                                                return {
                                                                                        TAG: "Error",
                                                                                        _0: "statementLengthRestriction must be one of: No, LessEq, Less."
                                                                                      };
                                                                              }
                                                                            }), undefined),
                                                                      maxNumberOfBranches: Expln_utils_jsonParse.intOpt(d, "maxNumberOfBranches", undefined, undefined)
                                                                    };
                                                            }), undefined, undefined);
                                              }), undefined, undefined)
                                      };
                              }), undefined, undefined);
                }), undefined, undefined);
          if (parseResult.TAG !== "Ok") {
            return Expln_utils_promise.promiseResolved({
                        TAG: "Error",
                        _0: parseResult._0
                      });
          }
          var apiParams = parseResult._0;
          var stmtToProve = state.stmts.find(function (stmt) {
                return stmt.label === apiParams.stepToProve;
              });
          if (stmtToProve === undefined) {
            return Expln_utils_promise.promiseResolved({
                        TAG: "Error",
                        _0: "Cannot find a step with the label '" + apiParams.stepToProve + "'"
                      });
          }
          var args = Core__Array.reduce(apiParams.frameParams, {
                TAG: "Ok",
                _0: []
              }, (function (res, frameParams) {
                  if (res.TAG !== "Ok") {
                    return {
                            TAG: "Error",
                            _0: res._0
                          };
                  }
                  var args = res._0;
                  var msg = labelsToExprs(state, frameParams.stepsToUse);
                  if (msg.TAG !== "Ok") {
                    return {
                            TAG: "Error",
                            _0: msg._0
                          };
                  }
                  args.push(msg._0);
                  return {
                          TAG: "Ok",
                          _0: args
                        };
                }));
          if (args.TAG !== "Ok") {
            return Expln_utils_promise.promiseResolved({
                        TAG: "Error",
                        _0: args._0
                      });
          }
          var args$1 = args._0;
          var matches = Core__Array.reduce(apiParams.frameParams, {
                TAG: "Ok",
                _0: []
              }, (function (res, frameParams) {
                  if (res.TAG !== "Ok") {
                    return {
                            TAG: "Error",
                            _0: res._0
                          };
                  }
                  var matches = res._0;
                  var msg = optArrayToMatchers(state, frameParams.matches);
                  if (msg.TAG !== "Ok") {
                    return {
                            TAG: "Error",
                            _0: msg._0
                          };
                  }
                  matches.push(msg._0);
                  return {
                          TAG: "Ok",
                          _0: matches
                        };
                }));
          if (matches.TAG !== "Ok") {
            return Expln_utils_promise.promiseResolved({
                        TAG: "Error",
                        _0: matches._0
                      });
          }
          var matches$1 = matches._0;
          return Expln_utils_promise.promiseMap(startProvingBottomUp({
                          delayBeforeStartMs: Belt_Option.getWithDefault(apiParams.delayBeforeStartMs, 1000),
                          stmtId: stmtToProve.id,
                          debugLevel: Belt_Option.getWithDefault(apiParams.debugLevel, 0),
                          bottomUpProverParams: {
                            maxSearchDepth: apiParams.maxSearchDepth,
                            frameParams: apiParams.frameParams.map(function (frameParams, i) {
                                  return {
                                          minDist: frameParams.minDist,
                                          maxDist: frameParams.maxDist,
                                          frmsToUse: Belt_Option.map(frameParams.framesToUse, (function (__x) {
                                                  if (lastPreCtxV.contents !== state.preCtxV) {
                                                    lastPreCtxV.contents = state.preCtxV;
                                                    sortedFrames.contents = Belt_HashMapString.make(64);
                                                  }
                                                  var framesStr = __x.join(" ");
                                                  var sorted = Belt_HashMapString.get(sortedFrames.contents, framesStr);
                                                  if (sorted !== undefined) {
                                                    return sorted;
                                                  }
                                                  var sorted$1 = MM_substitution.sortFrames(state.frms, __x);
                                                  Belt_HashMapString.set(sortedFrames.contents, framesStr, sorted$1);
                                                  return sorted$1;
                                                })),
                                          matches: matches$1[i],
                                          args: args$1[i],
                                          allowNewDisjForExistingVars: frameParams.allowNewDisjointsForExistingVariables,
                                          allowNewStmts: frameParams.allowNewSteps,
                                          allowNewVars: frameParams.allowNewVariables,
                                          lengthRestrict: MM_provers.lengthRestrictFromStrExn(frameParams.statementLengthRestriction),
                                          maxNumberOfBranches: frameParams.maxNumberOfBranches
                                        };
                                })
                          },
                          selectFirstFoundProof: Belt_Option.getWithDefault(apiParams.selectFirstFoundProof, false)
                        }), (function (proved) {
                        if (proved !== undefined) {
                          return {
                                  TAG: "Ok",
                                  _0: proved
                                };
                        } else {
                          return {
                                  TAG: "Ok",
                                  _0: null
                                };
                        }
                      }));
        }));
  unifyAllRef.contents = makeApiFunc("editor.unifyAll", (function (param) {
          if (canStartUnifyAll) {
            return Expln_utils_promise.promiseMap(startUnifyAll(), (function () {
                          return {
                                  TAG: "Ok",
                                  _0: null
                                };
                        }));
          } else {
            return Expln_utils_promise.promiseResolved({
                        TAG: "Error",
                        _0: "Cannot start \"Unify All\" because either there are syntax errors in the editor or edit is in progress."
                      });
          }
        }));
  addStepsRef.contents = makeApiFunc("editor.addSteps", (function (params) {
          var parseResult = Expln_utils_jsonParse.fromJson(params, (function (__x) {
                  return Expln_utils_jsonParse.asObj(__x, (function (d) {
                                return {
                                        atIdx: Expln_utils_jsonParse.intOpt(d, "atIdx", undefined, undefined),
                                        steps: Expln_utils_jsonParse.arr(d, "steps", (function (__x) {
                                                return Expln_utils_jsonParse.asObj(__x, (function (d) {
                                                              return {
                                                                      label: Expln_utils_jsonParse.strOpt(d, "label", undefined, undefined),
                                                                      typ: Expln_utils_jsonParse.strOpt(d, "type", validateStepType, undefined),
                                                                      stmt: Expln_utils_jsonParse.strOpt(d, "stmt", undefined, undefined),
                                                                      jstf: Expln_utils_jsonParse.strOpt(d, "jstf", undefined, undefined),
                                                                      isBkm: Expln_utils_jsonParse.bool(d, "isBkm", undefined, (function () {
                                                                              return false;
                                                                            }))
                                                                    };
                                                            }), undefined, undefined);
                                              }), undefined, undefined),
                                        vars: Expln_utils_jsonParse.arrOpt(d, "vars", (function (__x) {
                                                return Expln_utils_jsonParse.asArr(__x, (function (__x) {
                                                              return Expln_utils_jsonParse.asStr(__x, (function (str) {
                                                                            var trimed = str.trim();
                                                                            if (trimed === "") {
                                                                              return {
                                                                                      TAG: "Error",
                                                                                      _0: "Variable type and name must not be empty"
                                                                                    };
                                                                            } else {
                                                                              return {
                                                                                      TAG: "Ok",
                                                                                      _0: trimed
                                                                                    };
                                                                            }
                                                                          }), undefined);
                                                            }), undefined, undefined);
                                              }), undefined, undefined)
                                      };
                              }), undefined, undefined);
                }), undefined, undefined);
          if (parseResult.TAG !== "Ok") {
            return Expln_utils_promise.promiseResolved({
                        TAG: "Error",
                        _0: "Could not parse input parameters: " + parseResult._0
                      });
          }
          var parseResult$1 = parseResult._0;
          if (Belt_Option.getWithDefault(Belt_Option.map(parseResult$1.vars, (function (vars) {
                        return vars.some(function (a) {
                                    return a.length !== 2;
                                  });
                      })), false)) {
            return Expln_utils_promise.promiseResolved({
                        TAG: "Error",
                        _0: "Each sub-array of the 'vars' array must consist of two elements: [type,varName]."
                      });
          }
          var msg = validateVarNamesAreUnique(parseResult$1.vars);
          if (msg.TAG !== "Ok") {
            return Expln_utils_promise.promiseResolved({
                        TAG: "Error",
                        _0: msg._0
                      });
          }
          var msg$1 = validateVarNamesNotPresentInCtx(state, parseResult$1.vars);
          if (msg$1.TAG !== "Ok") {
            return Expln_utils_promise.promiseResolved({
                        TAG: "Error",
                        _0: msg$1._0
                      });
          }
          var steps = parseResult$1.steps.map(function (step) {
                return {
                        id: undefined,
                        label: step.label,
                        typ: Belt_Option.map(step.typ, MM_wrk_editor.userStmtTypeExtendedFromStrExn),
                        cont: step.stmt,
                        jstf: step.jstf,
                        isBkm: step.isBkm
                      };
              });
          var vars = Belt_Option.map(parseResult$1.vars, (function (vars) {
                  return vars.map(function ($$var) {
                              return [
                                      $$var[0],
                                      $$var[1]
                                    ];
                            });
                }));
          return setState(function (st) {
                      var match = validateVarNamesNotPresentInCtx(st, parseResult$1.vars);
                      var dontAddVariablesToContext;
                      dontAddVariablesToContext = match.TAG === "Ok" ? false : true;
                      var msg = MM_wrk_editor.addSteps(st, parseResult$1.atIdx, steps, vars, dontAddVariablesToContext);
                      if (msg.TAG !== "Ok") {
                        return {
                                TAG: "Error",
                                _0: msg._0
                              };
                      }
                      var match$1 = msg._0;
                      var st$1 = match$1[0];
                      var stmtIdToLabel = Belt_HashMapString.fromArray(st$1.stmts.map(function (stmt) {
                                return [
                                        stmt.id,
                                        stmt.label
                                      ];
                              }));
                      return {
                              TAG: "Ok",
                              _0: [
                                st$1,
                                match$1[1].map(function (stmtId) {
                                      return Belt_Option.getExn(Belt_HashMapString.get(stmtIdToLabel, stmtId));
                                    })
                              ]
                            };
                    });
        }));
  updateStepsRef.contents = makeApiFunc("editor.updateSteps", (function (params) {
          var parseResult = Expln_utils_jsonParse.fromJson(params, (function (__x) {
                  return Expln_utils_jsonParse.asArr(__x, (function (__x) {
                                return Expln_utils_jsonParse.asObj(__x, (function (d) {
                                              return {
                                                      label: Expln_utils_jsonParse.str(d, "label", undefined, undefined),
                                                      typ: Expln_utils_jsonParse.strOpt(d, "type", validateStepType, undefined),
                                                      stmt: Expln_utils_jsonParse.strOpt(d, "stmt", undefined, undefined),
                                                      jstf: Expln_utils_jsonParse.strOpt(d, "jstf", undefined, undefined),
                                                      isBkm: Expln_utils_jsonParse.boolOpt(d, "isBkm", undefined, undefined)
                                                    };
                                            }), undefined, undefined);
                              }), undefined, undefined);
                }), undefined, undefined);
          if (parseResult.TAG !== "Ok") {
            return Expln_utils_promise.promiseResolved({
                        TAG: "Error",
                        _0: "Could not parse input parameters: " + parseResult._0
                      });
          }
          var inputSteps = parseResult._0;
          return setState(function (st) {
                      var labelToStmtId = Belt_HashMapString.fromArray(st.stmts.map(function (stmt) {
                                return [
                                        stmt.label,
                                        stmt.id
                                      ];
                              }));
                      var stepWithoutId = inputSteps.find(function (step) {
                            return Belt_Option.isNone(Belt_HashMapString.get(labelToStmtId, step.label));
                          });
                      if (stepWithoutId !== undefined) {
                        return {
                                TAG: "Error",
                                _0: "Cannot find step with label '" + stepWithoutId.label + "'"
                              };
                      }
                      var steps = inputSteps.map(function (step) {
                            return {
                                    id: Belt_HashMapString.get(labelToStmtId, step.label),
                                    label: undefined,
                                    typ: Belt_Option.map(step.typ, MM_wrk_editor.userStmtTypeExtendedFromStrExn),
                                    cont: step.stmt,
                                    jstf: step.jstf,
                                    isBkm: step.isBkm
                                  };
                          });
                      var msg = MM_wrk_editor.updateSteps(st, steps);
                      if (msg.TAG === "Ok") {
                        return {
                                TAG: "Ok",
                                _0: [
                                  msg._0,
                                  true
                                ]
                              };
                      } else {
                        return {
                                TAG: "Error",
                                _0: msg._0
                              };
                      }
                    });
        }));
  deleteStepsRef.contents = makeApiFunc("editor.deleteSteps", (function (params) {
          var parseResult = Expln_utils_jsonParse.fromJson(params, (function (__x) {
                  return Expln_utils_jsonParse.asArr(__x, (function (__x) {
                                return Expln_utils_jsonParse.asStr(__x, undefined, undefined);
                              }), undefined, undefined);
                }), undefined, undefined);
          if (parseResult.TAG !== "Ok") {
            return Expln_utils_promise.promiseResolved({
                        TAG: "Error",
                        _0: "Could not parse input parameters: " + parseResult._0
                      });
          }
          var stepLabelsToDelete = parseResult._0;
          return setState(function (st) {
                      var labelToStmtId = Belt_HashMapString.fromArray(st.stmts.map(function (stmt) {
                                return [
                                        stmt.label,
                                        stmt.id
                                      ];
                              }));
                      var stepIdsToDelete = stepLabelsToDelete.map(function (label) {
                                return Belt_HashMapString.get(labelToStmtId, label);
                              }).filter(Belt_Option.isSome).map(Belt_Option.getExn);
                      return {
                              TAG: "Ok",
                              _0: [
                                MM_wrk_editor.deleteStmts(st, stepIdsToDelete),
                                null
                              ]
                            };
                    });
        }));
  getTokenTypeRef.contents = makeApiFunc("editor.getTokenType", (function (params) {
          var wrkCtx = state.wrkCtx;
          if (wrkCtx === undefined) {
            return Expln_utils_promise.promiseResolved({
                        TAG: "Error",
                        _0: "Cannot determine token type because the editor contains errors."
                      });
          }
          var token = Core__JSON.Decode.string(params);
          if (token === undefined) {
            return Expln_utils_promise.promiseResolved({
                        TAG: "Error",
                        _0: "The parameter of getTokenType() must me a string."
                      });
          }
          var tokenType = MM_context.getTokenType(Caml_option.valFromOption(wrkCtx), token);
          var tmp;
          if (tokenType !== undefined) {
            switch (tokenType) {
              case "C" :
                  tmp = "c";
                  break;
              case "V" :
                  tmp = "v";
                  break;
              case "F" :
                  tmp = "f";
                  break;
              case "E" :
                  tmp = "e";
                  break;
              case "A" :
                  tmp = "a";
                  break;
              case "P" :
                  tmp = "p";
                  break;
              
            }
          } else {
            tmp = null;
          }
          return Expln_utils_promise.promiseResolved({
                      TAG: "Ok",
                      _0: tmp
                    });
        }));
  substituteRef.contents = makeApiFunc("editor.substitute", (function (params) {
          var parseResult = Expln_utils_jsonParse.fromJson(params, (function (__x) {
                  return Expln_utils_jsonParse.asObj(__x, (function (d) {
                                return {
                                        what: Expln_utils_jsonParse.str(d, "what", undefined, undefined),
                                        with_: Expln_utils_jsonParse.str(d, "with_", undefined, undefined)
                                      };
                              }), undefined, undefined);
                }), undefined, undefined);
          if (parseResult.TAG !== "Ok") {
            return Expln_utils_promise.promiseResolved({
                        TAG: "Error",
                        _0: "Could not parse input parameters: " + parseResult._0
                      });
          }
          var parseResult$1 = parseResult._0;
          return setState(function (st) {
                      return Belt_Result.map(MM_wrk_editor_substitution.substitute(st, parseResult$1.what, parseResult$1.with_), (function (st) {
                                    return [
                                            st,
                                            null
                                          ];
                                  }));
                    });
        }));
  mergeDuplicatedStepsRef.contents = makeApiFunc("editor.mergeDuplicatedSteps", (function (param) {
          return setState(function (st) {
                      var match = MM_wrk_editor.autoMergeDuplicatedStatements(st, true);
                      var renamesJson = match[1].map(function (param) {
                            return [
                                    param[0],
                                    param[1]
                                  ];
                          });
                      return {
                              TAG: "Ok",
                              _0: [
                                match[0],
                                renamesJson
                              ]
                            };
                    });
        }));
  editorSetContIsHiddenRef.contents = makeApiFunc("editor.setContentIsHidden", (function (params) {
          var bool = Core__JSON.Decode.bool(params);
          if (bool !== undefined) {
            return Expln_utils_promise.promiseMap(setEditorContIsHidden(bool), (function () {
                          return {
                                  TAG: "Ok",
                                  _0: null
                                };
                        }));
          } else {
            return Expln_utils_promise.promiseResolved({
                        TAG: "Error",
                        _0: "The parameter of setContentIsHidden() must me a boolean."
                      });
          }
        }));
  editorBuildSyntaxTreesRef.contents = makeApiFunc("editor.buildSyntaxTrees", (function (params) {
          var wrkCtx = state.wrkCtx;
          if (wrkCtx === undefined) {
            return Expln_utils_promise.promiseResolved({
                        TAG: "Error",
                        _0: "Cannot build syntax trees because there are errors in the editor."
                      });
          }
          var wrkCtx$1 = Caml_option.valFromOption(wrkCtx);
          var parseResult = Expln_utils_jsonParse.fromJson(params, (function (__x) {
                  return Expln_utils_jsonParse.asArr(__x, (function (__x) {
                                return Expln_utils_jsonParse.asStr(__x, undefined, undefined);
                              }), undefined, undefined);
                }), undefined, undefined);
          if (parseResult.TAG !== "Ok") {
            return Expln_utils_promise.promiseResolved({
                        TAG: "Error",
                        _0: "Could not parse input parameters: " + parseResult._0
                      });
          }
          var msg = buildSyntaxTrees(parseResult._0);
          if (msg.TAG === "Ok") {
            return Expln_utils_promise.promiseResolved({
                        TAG: "Ok",
                        _0: msg._0.map(function (syntaxTree) {
                              if (syntaxTree.TAG === "Ok") {
                                return Object.fromEntries([
                                            [
                                              "err",
                                              null
                                            ],
                                            [
                                              "tree",
                                              syntaxTreeNodeToJson(syntaxTree._0, (function (__x) {
                                                      return MM_context.ctxIntToSymExn(wrkCtx$1, __x);
                                                    }))
                                            ]
                                          ]);
                              } else {
                                return Object.fromEntries([
                                            [
                                              "err",
                                              syntaxTree._0
                                            ],
                                            [
                                              "tree",
                                              null
                                            ]
                                          ]);
                              }
                            })
                      });
          } else {
            return Expln_utils_promise.promiseResolved({
                        TAG: "Error",
                        _0: msg._0
                      });
          }
        }));
}

exports.api = api;
exports.updateEditorApi = updateEditorApi;
exports.stmtToJson = stmtToJson;
exports.optArrayToMatchers = optArrayToMatchers;
/* sortedFrames Not a pure module */
